import MainLayout from "../../components/layout/MainLayout";
import { Outlet } from "react-router-dom";

const PrivateRoute = ({ children }: any) => {  
  return <MainLayout><Outlet /></MainLayout>;
};

export default PrivateRoute;
